import { useMemo } from "react";
import { matchPath } from "react-router-dom";
import { useTabContext } from "@/contexts/TabContext";
import { TabParamsProvider } from "@/contexts/TabParamsContext";
import type { TabRegistryEntry } from "@/types/tabs";

export function TabRenderer() {
  const { tabs, activeTabId, registry } = useTabContext();

  // Build a lookup map from routePattern → component
  const entryMap = useMemo(() => {
    const m = new Map<string, TabRegistryEntry>();
    for (const e of registry) m.set(e.routePattern, e);
    return m;
  }, [registry]);

  return (
    <>
      {tabs.map((tab) => {
        let entry = entryMap.get(tab.routePattern);
        // Fallback: try matchPath against all registry entries
        if (!entry) {
          for (const e of registry) {
            if (matchPath(e.routePattern, tab.path)) {
              entry = e;
              break;
            }
          }
        }
        if (!entry) return null;

        const Component = entry.component;
        const isActive = tab.id === activeTabId;

        return (
          <div
            key={tab.id}
            style={{ display: isActive ? "block" : "none" }}
            className="h-full overflow-auto"
          >
            <TabParamsProvider value={tab.params}>
              <Component />
            </TabParamsProvider>
          </div>
        );
      })}
    </>
  );
}
